export default __webpack_public_path__ + "static/brush-yellow-corner-right-f2081d965ce6198e2c7e9d61d4da2039.png";